export const portalContainer = document.createElement('div')
portalContainer.id = 'jk-portal-container'
document.body.appendChild(portalContainer)

export const tooltipContainer = document.createElement('div')
tooltipContainer.id = 'jk-tooltip-container'
portalContainer.appendChild(tooltipContainer)

export const dropdownMenuContainer = document.createElement('div')
dropdownMenuContainer.id = 'jk-dropdown-menu-container'
portalContainer.appendChild(dropdownMenuContainer)
